import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ChartUtilities } from '@app/shared/utils/chartData';
import { AuthService } from '@app/core/auth.service';
import { AssetManagementService, CardType } from '../asset-management-service';
import { DateUtils } from '@app/shared/utils/date.utils';
import { ErrorMessages } from '@app/shared/constants/constants';
import { MonthsEnum } from '@app/shared/constants/global.enum';
import { LOCATION_OPTIONS } from '../my-request/my-request-form/my-request-form.constants';
import { LoaderService } from '@app/shared/services/loader.service';

type InventoryItem = { inventory: string; count: number; [key: string]: any };

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrl: './inventory.component.scss',
})
export class InventoryComponent implements OnInit {
  isLoading: boolean = false;
  chartData: any;
  donutChartData: any[] = [];
  errorMessage: string | null = null;
  isChartReady: boolean = false;
  inventoryBaseData: any[] = [];
  inventoryDetails: any[] = [];
  locationOptions = LOCATION_OPTIONS;

  imageSrc: string = 'assets/img/no-data-found.png';

  chartType: 'doughnut' = 'doughnut';
  chartLabelKey: string = 'inventory';
  chartValueKey: string = 'count';
  legendItems: { label: string; value: number; color: string }[] = [];

  isDataLoaded: boolean = true;
  selectedLocation: string = 'Hyderabad';
  selectedMonth: string = '';
  monthSelected: any = null;
  yearSelected: any = null;
  errorMsg: string = ErrorMessages.NoDataAvailable;
  monthOptions: any[] = [];
  inventoryData: any[] = [];
  selectedMonthValue: string = '';
  constructor(
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    public readonly assetManagementService: AssetManagementService,
    private readonly route: ActivatedRoute,
    private authService: AuthService,
    public readonly loaderService: LoaderService,
  ) {
     this.monthOptions = DateUtils.generateMonthOptions();
    if (this.monthOptions.length > 0) {
      this.selectedMonthValue = this.monthOptions[0].value;
    }
  }

  ngOnInit(): void {
    const location = this.assetManagementService.getUserLocationFromSession();
    const foundLocation = this.locationOptions.find(
      (opt) => opt.value === location,
    );
    this.selectedLocation = foundLocation
      ? foundLocation?.value
      : this.locationOptions[0].value;
    this.getInventoryDetails(this.selectedLocation,this.selectedMonthValue);
  }

  private updateChartData(data: InventoryItem[]): void {
    this.isChartReady = false;

    if (data.length === 0) {
      this.chartData = null;
      this.donutChartData = [];
      this.cdr.detectChanges();
      return;
    }

    const palette = ChartUtilities.getChartColors();

    const inventoryItem = data.map((d, i) => {
      const color = palette[i % palette.length];
      return {
        ...d,
        color: color,
      };
    });

    const mappedColorsSample = inventoryItem.map((item) => ({
      inventory: item.inventory,
      count: item.count,
      color: item.color,
    }));

    this.legendItems = inventoryItem.map((d) => ({
      label: d.inventory,
      value: d.count,
      color: d.color,
    }));

    this.chartData = inventoryItem;
    this.donutChartData = inventoryItem;

    this.isChartReady = true;

    this.cdr.detectChanges();
  }

  private resetData(): void {
    this.inventoryBaseData = [];
    this.inventoryDetails = [];
    this.chartData = null;
    this.donutChartData = [];
    this.isChartReady = false;
  }

  onLocationChange(event: any) {
    if (event && typeof event === 'object') {
      this.selectedLocation = event.label;
    } else {
      this.selectedLocation = event;
    }
    this.getInventoryDetails(this.selectedLocation,this.selectedMonthValue);
  }

    handleMonthChange(selectedMonth: any,) {
    this.selectedMonthValue = selectedMonth;
    const [month, year] = selectedMonth.split(',').map((s: string) => s.trim());
    this.monthSelected = DateUtils.getMonthName(Number(month) - 1);
    this.yearSelected = year;
    // this.fetchDamageAnalyticsData(this.selectedLocation, this.monthSelected);
    this.getInventoryDetails(this.selectedLocation, this.selectedMonthValue);
  }

  private getInventoryDetails(location: string, monthYear: string): void {
    this.isLoading = true;
    this.isChartReady = false;
    const [month, year] = monthYear.split(',').map((s: string) => s.trim());
    this.assetManagementService.getInventoryData(location, month, year).subscribe({
      next: (response: any) => {
        this.isChartReady = true;

        let raw: any[] = [];

        if (Array.isArray(response)) {
          raw = response;
        } else if (
          response &&
          'data' in response &&
          Array.isArray(response.data)
        ) {
          raw = response.data;
        } else if (
          response &&
          'result' in response &&
          Array.isArray(response.result)
        ) {
          raw = response.result;
        }

        const analyticsData = raw.map((item: any) => ({
          inventory: item.itemName,
          count: item.totalQuantity,
        }));

        analyticsData.sort((a, b) => b.count - a.count);
        const top8Data = analyticsData.slice(0, 8);

        this.inventoryData = analyticsData;
        this.updateChartData(top8Data);
        this.errorMessage = null;
        this.isLoading = false;
      },
      error: () => {
        this.resetData();
        this.isLoading = false;
      },
    });
  }
  private toTitleCase(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  navigateToMyRequests(cardType: CardType = 'header'): void {
    
    localStorage.setItem('selectedCard', cardType);
    this.router.navigate(['accessories-management'], {
      relativeTo: this.route,
      state: {
       
        selectedLocation: this.selectedLocation,
      },
    });
  }

  navigateToInventoryTab() {
    this.navigateToMyRequests('inventory');
       this.router.navigate(['accessories-management'], {
         relativeTo: this.route,
         state: {
           selectedLocation: this.selectedLocation,
         },
       });
  }
}
